/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["hatinggabi", "tanghaling-tapat", "umaga", "madaling-araw", "sa hapon", "sa gabi", "gabi"], ["hatinggabi", "tanghaling-tapat", "nang umaga", "madaling-araw", "tanghali", "ng hapon", "gabi"], ["hatinggabi", "tanghaling-tapat", "nang umaga", "madaling-araw", "tanghali", "ng hapon", "ng gabi"]], [["hatinggabi", "tanghaling-tapat", "umaga", "madaling-araw", "tanghali", "gabi", "gabi"], ["hatinggabi", "tanghaling-tapat", "umaga", "madaling-araw", "tanghali", "hapon", "gabi"], u], ["00:00", "12:00", ["00:00", "06:00"], ["06:00", "12:00"], ["12:00", "16:00"], ["16:00", "18:00"], ["18:00", "24:00"]]];
